import { useSelector } from 'react-redux';
import { getIsFreemium } from '../../authSlice/authSelectors';

function useGetIsFreemium(): boolean {
  const isFreemium = useSelector(getIsFreemium);
  return isFreemium;
}

export default useGetIsFreemium;
